import { SET_APPLICATION_ID, SET_CURRENT_IDS, SET_PREV_DATA } from "../types";

const initialState = {
    prevData: null,
    applicationId: 0,
    formId: 0,
}

export const currentFormReducer = (state = initialState, action: { type: string, payload: any }) => {
    switch (action.type) {
        case SET_PREV_DATA:
            return { ...state, ...action.payload }
        case SET_APPLICATION_ID:
            return { ...state, ...action.payload }
        case SET_CURRENT_IDS:
            return { ...state, ...action.payload }
        default:
            return state;
    }
}